import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

const lineVariants = {
  hidden: { y: "110%" },
  show: (delay) => ({ y: "0%", transition: { duration: 1.1, delay, ease: EASE } }),
};

export const MaskLine = ({ children, delay = 0, className = "", inView = false }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0 } }
    : { animate: "show" };
  return (
    <motion.span className="block" initial="hidden" {...trigger}>
      <span className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span className={`block ${className}`} variants={lineVariants} custom={delay}>
          {children}
        </motion.span>
      </span>
    </motion.span>
  );
};

export const SectionLabel = ({ index, children, dark = false }) => (
  <div className="flex items-center gap-4">
    <span className={`font-display italic text-sm ${dark ? "text-white/60" : "text-[#5C564E]"}`}>{index}</span>
    <span className="h-px w-10 bg-[#B8874A]" />
    <span className="eyebrow">{children}</span>
  </div>
);
